const EARTH_RADIUS_KM = 6371.0088

const radians = (degrees) => degrees * Math.PI / 180
const degrees = (radiansValue) => radiansValue * 180 / Math.PI

// Great-circle destinations keep the requested radius honest at high
// latitudes; adding degrees would turn military ranges into ellipses.
export function rangeCircleCoordinates(center, radiusKm, steps = 96) {
  if (!center || !Number.isFinite(radiusKm) || radiusKm <= 0 || steps < 12) return []
  const [lng, lat] = center
  const angular = radiusKm / EARTH_RADIUS_KM
  const lat1 = radians(lat)
  const lng1 = radians(lng)
  const ring = []

  for (let index = 0; index <= steps; index += 1) {
    const bearing = 2 * Math.PI * index / steps
    const lat2 = Math.asin(
      Math.sin(lat1) * Math.cos(angular)
      + Math.cos(lat1) * Math.sin(angular) * Math.cos(bearing)
    )
    const lng2 = lng1 + Math.atan2(
      Math.sin(bearing) * Math.sin(angular) * Math.cos(lat1),
      Math.cos(angular) - Math.sin(lat1) * Math.sin(lat2)
    )
    // Keep longitudes unwrapped around the chosen centre. Normalising every
    // point to [-180, 180] introduces a 360° jump through dateline circles.
    ring.push([degrees(lng2), degrees(lat2)])
  }
  return ring
}

export function rangeCircleFeature(center, radiusKm, steps = 96) {
  const coordinates = rangeCircleCoordinates(center, radiusKm, steps)
  return coordinates.length ? {
    type: 'Feature',
    properties: { radius_km: radiusKm },
    geometry: { type: 'Polygon', coordinates: [coordinates] },
  } : null
}
